/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import useFechas from "../../hooks/useFechas";
// import ModalAdd from "./Modals/ModalAdd";
import DataTable from "../../components/DataTable/DataTable";
import { formatCurrency } from "../../utils/formato";
import Link from "../../components/Form/Link";
import Title from "../../components/Form/Title";
import { hideLoader, showLoader, setTitle } from "../../reducers/loaderReducer";
import { useDispatch } from "react-redux";
import useLogin from "../../hooks/useLogin";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { OrdenesPagoAdd } from "../../service/ordenesPago";
import { FacturaRevisar } from "../../service/facturas";
import { STORAGE_URL } from "../../config/env";

const Estado = ({ status }) => {
  if (status === "Pagado") {
    return (
      <div className="badge badge-outline-success text-success">Pagado</div>
    );
  }

  if (status === "Pendiente") {
    return (
      <div className="badge badge-outline-warning text-warning">Pendiente</div>
    );
  }

  return null;
};

/** La direccion del proveedor viene en campos separados. */
const direccionDe = (fila) =>
  [
    fila.calle,
    fila.exterior,
    fila.inerior,
    fila.colonia,
    fila.cp,
    fila.nom_mun,
    fila.nom_estado,
    fila.nom_pais,
  ].join(" ");

const construirColumnas = ({
  generatePDF,
  unirFacturas,
  facturasValue,
  userRol,
  sendArchivo,
  onRevisarFactura,
}) => {
  const puedeRevisarFacturas =
    userRol === "contabilidad" ||
    userRol === "super administrador" ||
    userRol === "administrador";
  const columnas = [
    { field: "folio", title: "Folio orden de pago" },
    { field: "proyecto", title: "Proyecto" },
    { field: "cuenta_padre", title: "Cuenta Padre" },
    { field: "cuenta_presupuental", title: "Cuenta Presupuestal" },
    { field: "fecha", title: "Fechas de pagos" },
    {
      field: "monto",
      title: "Monto",
      align: "center",
      sortValue: (fila) => Number(fila.monto) || 0,
      render: (fila) => formatCurrency(fila.monto),
    },
    {
      field: "status",
      title: "Status",
      filterable: false,
      align: "center",
      render: (fila) => <Estado status={fila.status} />,
    },
    {
      field: "factura",
      title: "Factura del proveedor",
      sortable: false,
      filterable: false,
      align: "center",
      render: (fila) => {
        if (!fila.factura_id) {
          return <span className="text-muted">Sin subir</span>;
        }

        const colorStatus =
          fila.factura_status === "Aprobada"
            ? "badge-outline-success text-success"
            : fila.factura_status === "Rechazada"
            ? "badge-outline-danger text-danger"
            : "badge-outline-info text-info";

        return (
          <div className="d-flex flex-column align-items-center gap-1">
            <span className={`badge ${colorStatus}`}>{fila.factura_status}</span>
            {fila.factura_xml && (
              <a href={`${STORAGE_URL}FacturasProveedor/${fila.factura_xml}`} target="_blank" rel="noreferrer">
                XML
              </a>
            )}
            {fila.factura_pdf && (
              <a href={`${STORAGE_URL}FacturasProveedor/${fila.factura_pdf}`} target="_blank" rel="noreferrer">
                PDF
              </a>
            )}
            {puedeRevisarFacturas && fila.factura_status === "Pendiente de revisión" && (
              <div className="d-flex gap-1 mt-1">
                <button
                  type="button"
                  className="btn btn-success btn-sm"
                  onClick={() => onRevisarFactura(fila.factura_id, "Aprobada")}
                >
                  Aprobar
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={() => onRevisarFactura(fila.factura_id, "Rechazada")}
                >
                  Rechazar
                </button>
              </div>
            )}
          </div>
        );
      },
    },
    {
      field: "unir",
      title: "Unir Facturas",
      sortable: false,
      filterable: false,
      align: "center",
      render: (fila) => {
        // Solo se pueden unir las que aun no tienen folio (no importa la
        // semana: las fechas de pago suelen programarse con meses de
        // anticipacion y antes esto las escondia hasta la semana exacta).
        if (fila.folio != null) return null;

        return (
          <input
            type="checkbox"
            checked={facturasValue.some((valor) => valor === fila.id)}
            onChange={() => unirFacturas(fila.id)}
          />
        );
      },
    },
    {
      field: "orden_pdf",
      title: "Orden PDF",
      sortable: false,
      filterable: false,
      align: "center",
      render: (fila) =>
        fila.folio != null && (
          <button
            className="btn btn-danger btn-sm"
            onClick={() => generatePDF(fila)}
          >
            PDF
          </button>
        ),
    },
  ];

  if (userRol === "contabilidad" || userRol === "super administrador") {
    columnas.push({
      field: "ficha",
      title: "Ficha de pago",
      sortable: false,
      filterable: false,
      align: "center",
      render: (fila) =>
        fila.folio != null && (
          <input
            type="file"
            className="btn btn-dark btn-sm text-white"
            onChange={(evento) => sendArchivo(evento, fila.folio)}
          />
        ),
    });
  }

  return columnas;
};



// arreglo de productos
const Prducts = [
  {
    id: "1",
    cantidad: "1",
    descripcion: "Contador de producción en set",
    partida: "1003",
    importe: 10000,
  },
  {
    id: "2",
    cantidad: "1",
    descripcion: "Contador de producción en set",
    partida: "1002",
    importe: 20000,
  },
];

// fecha actual
const date = new Date();

export default function Index() {
  const { token, cliente_id, user_rol } = useLogin();
  const dispatch = useDispatch();
  const {
    loading,
    error,
    message,
    success,
    Fecha,
    FechasGetService,
    FechasOrdenAddService,
  } = useFechas();
  const [Confirmar, setConfirmar] = useState(false);
  const [Facturas, setFacturas] = useState([]);
  const [FacturasValue, setFacturasValue] = useState([]);
  const [FechaPago, setFechaPago] = useState("");
  const { id } = useParams();
  let i = 1;

  useEffect(() => {
    dispatch(setTitle("Descargando Fechas de pago"));
    dispatch(showLoader());
    FechasGetService(id, token);
    return () => {};
  }, [id]);

  useEffect(() => {
    if (Fecha.length >= 0) {
      dispatch(hideLoader());
      dispatch(setTitle(""));
    }
    return () => {};
  }, [Fecha]);

  useEffect(() => {
    if (success === true) {
      FechasGetService(id, token);
    }
  }, [FechasGetService, success, id]);

  const formatNumber = (number) =>
    new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(number);

  useEffect(() => {
    if (success) {
      Swal.close();
      Swal.fire({
        icon: "success",
        title: "Exito",
        confirmButtonColor: "#3b82f6",
        text: message,
      });
    }
  }, [message, success]);

  // jspdf y su autotable pesan ~1.4 MB de fuente. Se cargan al generar el
  // PDF para que no viajen en el bundle inicial.
  //
  // Antes "PAGO A FAVOR DE" (nombre, RFC, banco, CLABE) venía fijo en el
  // código con los datos de otra empresa, sin importar a qué proveedor se le
  // estaba pagando -- un documento de pago real mostrando el banco
  // equivocado. También había 5 llamadas a autoTable(doc, {html:"#..."}) que
  // buscaban elementos que nunca existieron en la página: no hacían nada,
  // eran restos de una plantilla copiada.
  const generatePDF = async (fila) => {
    const { default: jsPDF } = await import("jspdf");
    const { default: autoTable } = await import("jspdf-autotable");
    const doc = new jsPDF();
    let subtotal = 0;

    const fehca_pago = fila.fecha_pago;
    const proyecto = fila.proyecto;
    const empresa = fila.empresa;
    const created_at = fila.created_at;
    const direecion = direccionDe(fila);
    const ordenes_pagos = JSON.parse(fila.ordenes_pagos);

    const nombreProveedor =
      [fila.proveedor_nombre, fila.proveedor_apellido_p, fila.proveedor_apellido_m]
        .filter(Boolean)
        .join(" ") || "Proveedor sin nombre registrado";
    const rfcProveedor = fila.proveedor_rfc || "Sin RFC registrado";
    const bancoProveedor = fila.proveedor_banco || "Sin banco registrado";
    const clabeProveedor = fila.proveedor_clabe || "Sin CLABE registrada";
    const productor = fila.productor || "—";
    const director = fila.director_de_produccion || "—";
    const ejecutivo = fila.productor_ejecutivo || "—";

    var img = new Image();
    img.src = "/logo-login.jpg";
    //img.src = "/incidencias/images/Logo_Horizontal_ANAM.png";
    doc.addImage(img, "png", 10, 10, 80, 20);
    doc.setFontSize(12);
    doc.text(110, 10, fila.nombre_comercial);
    doc.setFontSize(10);
    doc.text(110, 15, "RFC: " + fila.RFC);
    doc.text(110, 20, direecion, {
      align: "left",
      lineHeightFactor: 1,
      maxWidth: 100,
    });
    doc.text(110, 29, proyecto);
    doc.text(110, 33, "(" + empresa + ")");
    doc.text(110, 38, "SOLICITUD DE PAGO No. " + (fila.folio ?? ""));
    doc.text(110, 43, "FECHA DE ELABORACION: " + created_at);

    autoTable(doc, {
      theme: "grid",
      body: [
        [
          "PERIODO DE PAGO",
          "Del " +
            getFirstDayOfWeek(date) +
            " al " +
            getLastDayOfWeek(date) +
            " del " +
            date.getFullYear(),
          "SEMANA",
          getWeek(date) - 1,
        ],
        [
          { content: "FECHA DE PAGO", colSpan: 1 },
          { content: fehca_pago, colSpan: 1 },
          { content: "FORMA DE PAGO", colSpan: 1 },
          { content: "03 - Transferencia electrónica de fondos", colSpan: 3 },
        ],
      ],

      startY: 50,
    });

    autoTable(doc, {
      theme: "plain",
      body: [
        ["PROVEEDOR DEL SERVICIO", nombreProveedor],
        ["PAGO A FAVOR DE:", nombreProveedor],
        ["R. F. C.", rfcProveedor],
        ["BANCO", bancoProveedor],
        ["CUENTA - CLABE", clabeProveedor],
      ],

      startY: 73,
    });

    autoTable(doc, {
      theme: "striped",
      head: [["CANTIDAD", "DESCRIPCIÓN", "PARTIDA P", "IMPORTE"]],
      body: ordenes_pagos.map((product) => {
        subtotal += product.monto;
        return [
          1,
          product.nombre,
          { content: product.cuenta_presupuental, styles: { halign: "center" } },
          {
            content: "$" + formatNumber(product.monto),
            styles: { halign: "right" },
          },
        ];
      }),
      foot: [
        [
          "",
          "",
          "SUBTOTAL",
          { content: "$" + formatNumber(subtotal), styles: { halign: "right" } },
        ],
        [
          "",
          "",
          "IVA",
          { content: "$" + formatNumber(subtotal*0.16), styles: { halign: "right" } },
        ],
        [
          "",
          "",
          "TOTAL A PAGAR",
          { content: "$" + formatNumber(subtotal*1.16), styles: { halign: "right" } },
        ],
      ],

      startY: 115,
    });

    autoTable(doc, {
      theme: "grid",
      body: [
        ["PRODUCTOR", "DIRECCIÓN DE PRODUCCIÓN", "PRODUCTOR EJECUTIVO"],
        [productor, director, ejecutivo],
      ],
    });

    autoTable(doc, {
      theme: "plain",
      body: [
        [
          "Nota",
          "El pago se hará a la cuenta bancaria indicada en esta solicitud de pago, por lo que se solicita a la empresa proveedora de servicios, que en caso de no ser la misma cuenta bancaria, se indique la cuenta a la que se hará el depósito.",
        ],
      ],
    });

    // doc.text(
    //   15,
    //   200,
    //   "Nota: ",
    //   { align: "left", lineHeightFactor: 1, maxWidth: 180 }
    // );

    // doc.save("demo.pdf");
    window.open(
      doc.output("bloburl"),
      "_blank",
      "toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,modal=yes,top=100,left=250,width=1200,height=800"
    );
  };

  const sendArchivo = (e, folio) => {
    // send comprobante_pago fetch post OrdenesPagoAdd
    const formData = new FormData();
    formData.append("comprobante_pago", e.target.files[0]);
    formData.append("folio", folio);

    OrdenesPagoAdd(folio, formData, token).then((response) => {
      if(response.success){
        FechasGetService(id, token);
      }else{
        // Swal error message
        Swal.fire({
          icon: "danger",
          title: "Error",
          confirmButtonColor: "#3b82f6",
          text: "Hubo un error al subir el archivo",
        });
      }
    });
  };

  const UnirFacturas = (e) => {
    const newFactura =
      FacturasValue.some((value) => value == e) === true ? true : false;
    let facturasLength = [];
    if (newFactura) {
      facturasLength = FacturasValue.filter((value) => value != e);
      setFacturasValue(FacturasValue.filter((value) => value != e));
      setFacturas(Facturas.filter((value) => value.e != e));
    } else {
      facturasLength = [...FacturasValue, e];
      setFacturasValue([...FacturasValue, e]);
      setFacturas([...Facturas, { id: e }]);
      setConfirmar(true);
    }

    let cantidad = facturasLength.length;
    if (cantidad == 0) {
      setConfirmar(false);
    } else {
      setConfirmar(true);
    }
  };

  const getWeek = (date) => {
    const onejan = new Date(date.getFullYear(), 0, 1);
    return Math.ceil(((date - onejan) / 86400000 + onejan.getDay() + 1) / 7);
  };

  const getFirstDayOfWeek = (date) => {
    const day = date.getDay();
    const diff = date.getDate() - day + (day == 0 ? -6 : 1);
    const firstDay = new Date(date.setDate(diff));
    return firstDay.getDate() + " de " + getMonthName(firstDay.getMonth() + 1);
  };
  const getLastDayOfWeek = (date) => {
    const day = date.getDay();
    const diff = date.getDate() - day + (day == 0 ? -6 : 1) + 6;
    const lastDay = new Date(date.setDate(diff));
    return lastDay.getDate() + " de " + getMonthName(lastDay.getMonth() + 1);
  };
  // funcion mes en letras
  const getMonthName = (month) => {
    switch (month) {
      case 1:
        return "Enero";
      case 2:
        return "Febrero";
      case 3:
        return "Marzo";
      case 4:
        return "Abril";
      case 5:
        return "Mayo";
      case 6:
        return "Junio";
      case 7:
        return "Julio";
      case 8:
        return "Agosto";
      case 9:
        return "Septiembre";
      case 10:
        return "Octubre";
      case 11:
        return "Noviembre";
      case 12:
        return "Diciembre";
      default:
        return "Mes no encontrado";
    }
  };

  const createOrden = () => {
    // validar que FechaPago no sea null
    if (FechaPago == "") {
      Swal.fire({
        title: "Error",
        text: "Seleccione una fecha de pago",
        icon: "error",
        confirmButtonText: "Aceptar",
      });
    } else {
      const data = new FormData();
      data.append("cliente_id", cliente_id);
      data.append("facturas", FacturasValue);
      data.append("fecha_pago", FechaPago);

      FechasOrdenAddService(data, token);

      Swal.fire({
        title: "Registrando orden de pago",
        text: "Loading...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        icon: "question",
        onOpen: () => {
          Swal.showLoading();
        },
      });
    }
  };

  const revisarFactura = async (facturaId, status) => {
    let motivo_rechazo;

    if (status === "Rechazada") {
      const { value, isConfirmed } = await Swal.fire({
        icon: "warning",
        title: "Rechazar factura",
        input: "text",
        inputLabel: "¿Por qué se rechaza?",
        inputPlaceholder: "Motivo del rechazo",
        showCancelButton: true,
        confirmButtonText: "Rechazar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#dc2626",
        inputValidator: (valor) => (!valor ? "Escribe el motivo" : undefined),
      });
      if (!isConfirmed) return;
      motivo_rechazo = value;
    } else {
      const confirmacion = await Swal.fire({
        icon: "question",
        title: "¿Aprobar esta factura?",
        showCancelButton: true,
        confirmButtonText: "Sí, aprobar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#2f3a34",
      });
      if (!confirmacion.isConfirmed) return;
    }

    const respuesta = await FacturaRevisar({ id: facturaId, status, motivo_rechazo }, token);

    if (respuesta?.errors) {
      const primerError = Object.values(respuesta.errors)[0]?.[0];
      Swal.fire({ icon: "error", title: "No se pudo guardar", text: primerError });
      return;
    }

    if (respuesta?.guardado) {
      Swal.fire({ icon: "success", title: status === "Aprobada" ? "Factura aprobada" : "Factura rechazada" });
      FechasGetService(id, token);
    } else {
      Swal.fire({ icon: "error", title: "No se pudo guardar", text: "Intenta de nuevo." });
    }
  };

  const columnas = construirColumnas({
    generatePDF,
    unirFacturas: UnirFacturas,
    facturasValue: FacturasValue,
    userRol: user_rol,
    sendArchivo,
    onRevisarFactura: revisarFactura,
  });

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-6">
            <Title title="Listado de Fechas de pago" className="text-left" />
          </div>
          {Confirmar == true ? (
            <div className="col-md-6 text-end">
              <div class="input-group mb-3">
                <input
                  type="date"
                  class="form-control"
                  value={FechaPago}
                  onChange={(e) => setFechaPago(e.target.value)}
                />
                <button
                  class="btn btn-outline-primary"
                  type="button"
                  id="button-addon2"
                  onClick={() => createOrden()}
                >
                  Confirmar facturas
                </button>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
        <br />
        <div className="row">
          <div className="col-md-12">
            <div className="crud-card">
              <DataTable tableKey="fechas-pago-detalle" loading={loading} columns={columnas} data={Fecha} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
